import type {
  ResidentDefaultFormValues,
  ResidentMessageFormValues,
  ReviewCheckboxForm,
} from '../types'

/** Blank Resident detail form — every control the Default/Reimbursement tabs bind to. */
export const RESIDENT_DEFAULT_FORM_VALUES: ResidentDefaultFormValues = {
  unit_number: '',
  property_unused_security_deposit: '',
  unused_security_deposit: '',
  security_deposit_change_reasons: '',
  claim_status: '',
  reimbursement_type: '',
  rental_status: '',
  rental_progress: '',
  reimbursement_rental_status: '',
  reimbursement_rental_progress: '',
  rental_status_date: '',
  reason_for_default: '',
  lease_agreement: '',
  payment_ledger: '',
  skip_claim_affidavit: '',
  skip_claim_affidavit_required: '',
  eviction_lawsuit: '',
  jurisdiction_eviction_updates: '',
  other_supporting_documents: '',
  cdc_declaration: '0',
  payment_plan: '0',
  cdc_affidavit: '',
  lease_agreement_status: '',
  payment_ledger_status: '',
  is_final_ledger: '',
  skip_claim_affidavit_status: '',
  unlawful_detainer_status: '',
  late_letter: '',
  date_unit_is_back_on_market: '',
  adjust_max_movein_date: '',
  movein_date: '',
  new_resident_lease_start_date: '',
  moveout_date: '',
  unit_vacancy: '',
  covid_19: '0',
  partial_payment_amount: '0.00',
  notes: '',
  message: '',
  adjusted_notice: '',
  adjusted_reason: '',
  loss_adjustment: '0.00',
  loss_adjusted_reason: '',
  net_amount: '',
  first_month_not_paid_month: '',
  first_month_not_paid_year: '',
  lease_month: '',
  timely: 'NO',
  lease_start_date: '',
  lease_end_date: '',
  lease_verified: '0',
  claim_expiration_date: '',
}

/** Blank insurance/authorization message form on the Liberty Internal tab. */
export const RESIDENT_MESSAGE_FORM_VALUES: ResidentMessageFormValues = {
  insurance_review_approval: '',
  insurance_review_ready: '',
  message_insurance: '',
  liberty_authorization_ready: '',
  liberty_approved: '',
}

/** Blank checkbox state for the Review Resident dialog. */
export const EMPTY_REVIEW_CHECKBOX_FORM: ReviewCheckboxForm = {
  lease_agreement: false,
  final_payment_ledger: false,
  legal_forms: false,
  notification_date: false,
  notes: '',
}
